<app-loader [showLoader]="showLoad"> </app-loader>
<div class="overview printable_button_r3">
	<app-printable-report-r1></app-printable-report-r1>
</div>
<div class="no-data-container" *ngIf="noData">
	<div class="map-no-data">No Data to Display</div>
</div>
<div class="c-portlet u-bg-main u-shadow-mini map-v3-container" (window:resize)="onResize($event)">
	<div
		class="analytics-campaign-charts-header c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini"
	>
		<div class="o-stack__cell">
			<h5>Map</h5>
		</div>
	</div>
	<div class="c-portlet__content pos-relative">
		<div>
			<div class="map-wrapper">
				<div id="map"></div>
				<div id="geofence-disclaimer" class="geofence-disclaimer">
					<div class="geofence-disclaimer-section">
						<img class="geofence-disclaimer-img" src="../../../../../../assets/images/info-circle.png" />
						<span class="geofence-disclaimer-text"
							>Geofence/geo recency points may not display due to category-specific privacy restrictions in a selected
							campaign.</span
						>
					</div>
				</div>
			</div>
			<div class="map-details-container">
				<div class="details-map-container">
					<div id="minimap" class="height-100p"></div>
				</div>
			</div>
			<div class="zoom-options-container">
				<div class="zoom-icon" (click)="zoomIn()">
					<i class="fa fa-plus" aria-hidden="true"></i>
				</div>
				<div class="zoom-icon zoom-out-icon" (click)="zoomOut()">
					<i class="fa fa-minus" aria-hidden="true"></i>
				</div>
			</div>
		</div>
		<div class="map-no-data-container" *ngIf="noData">
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>

	<div class="detailcards detail-colors">
		<div class="locationcard primary-color-border">
			<div class="containericon location-details" *ngIf="polygonLayerDetails?.zip || geofenceCenterDetails?.address">
				<div class="pageflex subtext-font add-color" [ngClass]="{ 'location-info': !showGeofenceCenterDetailsFlag }">
					<div *ngIf="polygonLayerDetails?.zip">
						<div class="primary-color">
							<b>Postal Code:</b> {{ polygonLayerDetails?.zip ? polygonLayerDetails?.zip : '--' }}
						</div>
						<div class="primary-color location">
							{{ polygonLayerDetails?.regionName ? polygonLayerDetails?.regionName : '--'
							}}<span *ngIf="showGeofenceCenterDetailsFlag"
								>, {{ polygonLayerDetails?.zip ? polygonLayerDetails?.zip : '--' }}</span
							>
						</div>
						<div
							class="primary-color"
							[ngStyle]="{ 'border-bottom': showGeofenceCenterDetailsFlag ? '2px dotted #4a4a4a' : 'none' }"
						>
							<b>Population:</b> {{ polygonLayerDetails?.population ? polygonLayerDetails?.population : '--' }}
						</div>
					</div>
					<div class="map-details-wrapper" *ngIf="showGeofenceCenterDetailsFlag">
						<div class="map-region-dmographic-title primary-color">
							{{ geofenceCenterDetails ? geofenceCenterDetails?.name : '' }}
						</div>
						<div class="map-region-detail-container">
							<span class="map-region-dmographic-value primary-color">
								<b>{{ geofenceCenterDetails ? geofenceCenterDetails?.total_impression_sum : '' }}</b>
								Imprs&nbsp;&nbsp;|</span
							>
							<span class="map-region-dmographic-value primary-color">
								<b>{{ geofenceCenterDetails ? geofenceCenterDetails?.click_through_rate : '' }}%</b>
								CTR&nbsp;&nbsp;|</span
							>
							<span class="map-region-dmographic-value primary-color"
								>&nbsp;
								<b>{{ showGeofenceCenterDetailsFlag ? geofenceCenterDetails?.total_click_sum : '' }}</b> Clicks</span
							>
						</div>

						<div class="map-region-detail-container">
							<span class="map-region-dmographic-value primary-color">
								<b>{{ geofenceCenterDetails ? geofenceCenterDetails?.total_ios : '' }}% </b>
								iOS&nbsp;&nbsp; |
							</span>
							<span class="map-region-dmographic-value primary-color">
								<b>{{ geofenceCenterDetails ? geofenceCenterDetails?.total_android : '' }}%</b>
								Android</span
							>
						</div>
					</div>
				</div>
			</div>
			<p
				class="subtext-font primary-color location-details location-info"
				*ngIf="!(polygonLayerDetails && polygonLayerDetails?.zip) && !geofenceCenterDetails?.name"
			>
				<span *ngIf="noRegionData; else mapData">Map not available for selected product</span>
				<ng-template #mapData><span>Hover Map for Postal Code Details</span></ng-template>
			</p>
		</div>
		<div class="cardavg primary-color-bg-gradient">
			<div class="liftdat" *ngIf="hasLiftData">
				<div class="details" *ngIf="showLiftData && polygonLayerDetails?.avgLift">
					{{ polygonLayerDetails?.avgLift }}x
				</div>
				<div class="details" *ngIf="!polygonLayerDetails?.avgLift || !showLiftData">--x</div>
				<!--   rating  -->
				<div>
					<span
						class="ratingPer title-font liftDat-ratingPer"
						*ngIf="showLiftData && polygonLayerDetails?.averageBaseline"
					>
						{{ polygonLayerDetails?.averageBaseline }}% Baseline Rate</span
					>
					<span
						class="ratingPer title-font liftDat-ratingPer"
						*ngIf="!polygonLayerDetails?.averageBaseline || !showLiftData"
						>--%</span
					>
				</div>
				<div class="ratingtext">
					<span
						class="ratingPer title-font liftDat-ratingPer"
						*ngIf="showLiftData && polygonLayerDetails?.averageExposeRate"
						>{{ polygonLayerDetails?.averageExposeRate }}% Exposed Rate</span
					>
					<span
						class="ratingPer title-font liftDat-ratingPer"
						*ngIf="!polygonLayerDetails?.averageExposeRate || !showLiftData"
						>--%</span
					>
				</div>
			</div>
			<div class="righthomeper" *ngIf="hasLiftData">
				<!--  first -->
				<div class="col-container subtext-font">
					<div class="avghomevalue col">
						<i class="fa fa-circle homeicon" aria-hidden="true"></i>
						<span>Avg Home Value</span>
					</div>

					<div class="avghomevalue">
						<span *ngIf="polygonLayerDetails?.avgHomeValue"
							>${{ polygonLayerDetails?.avgHomeValue | formatNumber }}</span
						>
						<span *ngIf="!polygonLayerDetails?.avgHomeValue">--</span>
					</div>

					<div class="avghomeper">
						<i class="fa fa-caret-down" *ngIf="polygonLayerDetails?.avgHomeValue"></i>
						<span *ngIf="polygonLayerDetails?.avgHomeValue"
							>{{ polygonLayerDetails?.percentageAvgHomeValue }}% Avg</span
						>
						<span *ngIf="!polygonLayerDetails?.avgHomeValue">--</span>
					</div>
				</div>
				<!--  second -->
				<div class="col-container subtext-font">
					<div class="mediumage col">
						<i class="fa fa-circle homeicon" aria-hidden="true"></i>
						<span>Median Age</span>
					</div>
					<div class="mediumage col">
						<span *ngIf="polygonLayerDetails?.avgMedianAge">{{ polygonLayerDetails?.avgMedianAge }}</span>
						<span *ngIf="!polygonLayerDetails?.avgMedianAge">--</span>
					</div>

					<div class="mediumageper">
						<i class="fa fa-caret-down" *ngIf="polygonLayerDetails?.avgMedianAge"></i>
						<span *ngIf="polygonLayerDetails?.avgMedianAge">
							{{ polygonLayerDetails?.percentageAvgMedianAge }}% Avg</span
						>
						<span *ngIf="!polygonLayerDetails?.avgMedianAge">--</span>
					</div>
				</div>

				<!--  thirs -->
				<div class="col-container subtext-font">
					<div class="avgicomevalue col">
						<i class="fa fa-circle homeicon" aria-hidden="true"></i>
						<span>Avg Income</span>
					</div>
					<div class="avgicomevalue col">
						<p *ngIf="polygonLayerDetails?.avgIncome">${{ polygonLayerDetails?.avgIncome | formatNumber }}</p>
						<span *ngIf="!polygonLayerDetails?.avgIncome">--</span>
					</div>
					<div class="avgincome">
						<i class="fa fa-caret-down" *ngIf="polygonLayerDetails?.avgIncome"></i>
						<span *ngIf="polygonLayerDetails?.avgIncome">{{ polygonLayerDetails?.percentageAvgIncome }}% Avg</span>
						<span *ngIf="!polygonLayerDetails?.avgIncome">--% Avg</span>
					</div>
				</div>

				<!--  4th -->
				<div class="precontainer subtext-font">
					<div class="perhousehold">
						<i class="fa fa-circle homeicon" aria-hidden="true"></i>
						<span>Avg # Per Household</span>
					</div>
					<div class="perhousehold">
						<p *ngIf="polygonLayerDetails?.avgOccupancy">{{ polygonLayerDetails?.avgOccupancy }}</p>
						<p *ngIf="!polygonLayerDetails?.avgOccupancy">--</p>
					</div>
					<div class="avehousehold">
						<i class="fa fa-caret-up" *ngIf="polygonLayerDetails?.avgOccupancy"></i>
						<span *ngIf="polygonLayerDetails?.avgOccupancy"
							>{{ polygonLayerDetails?.percentageAvgOccupancy }}% Avg</span
						>
						<span *ngIf="!polygonLayerDetails?.avgOccupancy">--% Avg</span>
					</div>
				</div>
			</div>
			<div class="no-lift-message-cntr" *ngIf="!hasLiftData">
				<h4 class="no-lift-message-header header-font">
					Campaigns in the selected date range are not eligible for lift reporting.
				</h4>
				<div class="header-font">A Campaign must meet the following 3 requirements to receive lift reporting:</div>
				<div class="no-lift-message">
					<div class="no-lift-dot"></div>
					Campaign must have the pixel placed and firing on the website
				</div>
				<div class="no-lift-message">
					<div class="no-lift-dot"></div>
					Campaign must run for 3 consecutive months
				</div>
				<div class="no-lift-message">
					<div class="no-lift-dot"></div>
					Campaign must run at least 50,000 audience extension impressions per month
				</div>
			</div>
		</div>
	</div>
</div>
<div class="map-overview-stats-r3">
	<app-overview-r3-stats
		[key]="tertiarykey"
		uniqueoverwriteid="overview-map-quick-stats"
		(selectedLegend)="selectedProductLegendDetails($event)"
	></app-overview-r3-stats>
</div>
